import { useMemo } from 'react';
import { wrapRefs } from '../utils';
export function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return useMemo(function () {
    return wrapRefs.apply(void 0, refs);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}